{% block sw_cms_element_acris_blog_content_preview %}
    <div class="sw-cms-el-preview-acris-blog-content">
        <p>{{ $tc('acris-blog.elements.blogContent.preview.content') }}</p>
    </div>
{% endblock %}